/**
 * 적재·수거 원장 목 데이터. 출처: 와이어프레임 `confirmDD`(1407행) 확약 드롭다운 3종.
 *
 * 🔴 **「적재 완료」·「수거 확약」 버튼의 활성 근거는 `allowed_commands` 가 아니다.**
 *    `Batch.allowed_commands` enum 은 `start·stop·pause·resume·recover` 다섯뿐이고
 *    확약은 `POST /loads/{id}/confirm` · `POST /unloads/{id}/confirm` 이라는 별도 경로다.
 *    활성 근거 = **`confirmed_at === null` 인 원장 행이 있는가.** 두 축을 섞지 마라.
 */
import type { TrayLoad, TrayUnload } from '@ctcells/contract'

/** 적재 대기 중. 🔴 `confirmed_at: null` 이 「적재 완료」 버튼을 띄우는 근거다 */
export const TRAY_LOAD_PENDING: TrayLoad = {
  load_id: 'ld-260911-02-cent',
  batch_id: 'B-260911-02',
  module_id: 'cent',
  point_id: 'inlet',
  opened_at: '2026-09-11T13:56:53+09:00',
  confirmed_at: null,
  confirm_source: null,
  confirmed_by: null,
  attribution_basis: null,
  loaded_chambers: null,
  // 임계 시간을 넘겨 LOAD_OVERDUE 가 발행됐다
  overdue_notified_at: '2026-09-11T14:09:12+09:00',
  note: null,
}

/** 확약 완료. 확약 창구(`confirm_source`)는 「누가」가 아니라 「어디서」다 */
export const TRAY_LOAD_CONFIRMED: TrayLoad = {
  ...TRAY_LOAD_PENDING,
  load_id: 'ld-260911-01-cent',
  batch_id: 'B-260911-01',
  opened_at: '2026-09-11T02:55:00+09:00',
  confirmed_at: '2026-09-11T03:01:30+09:00',
  confirm_source: 'module_local',
  confirmed_by: 'hyungwoo.cho',
  attribution_basis: 'authenticated_session',
  loaded_chambers: 9,
  overdue_notified_at: null,
}

export const TRAY_LOADS: TrayLoad[] = [TRAY_LOAD_PENDING, TRAY_LOAD_CONFIRMED]

/** 수거 대기 중. 배치는 이미 `completed` 여도 이 행은 살아 있을 수 있다 */
export const TRAY_UNLOAD_PENDING: TrayUnload = {
  unload_id: 'ul-260911-01-stain',
  batch_id: 'B-260911-01',
  module_id: 'stain',
  point_id: 'outlet',
  opened_at: '2026-09-11T11:58:10+09:00',
  confirmed_at: null,
  confirm_source: null,
  confirmed_by: null,
  attribution_basis: null,
  overdue_notified_at: null,
  note: null,
}

/** 무인증 로컬 확약 — `confirmed_by` 가 null 이고 귀속 근거는 `attribution_basis` 가 쥔다 */
export const TRAY_UNLOAD_CONFIRMED: TrayUnload = {
  ...TRAY_UNLOAD_PENDING,
  unload_id: 'ul-260910-03-stain',
  batch_id: 'B-260910-03',
  opened_at: '2026-09-10T11:31:00+09:00',
  confirmed_at: '2026-09-10T11:44:00+09:00',
  confirm_source: 'module_local',
  confirmed_by: null,
  attribution_basis: 'batch_owner',
}

export const TRAY_UNLOADS: TrayUnload[] = [TRAY_UNLOAD_PENDING, TRAY_UNLOAD_CONFIRMED]
